export default __webpack_public_path__ + "static/media/Sharjah-Research-Technology-and-Innovation-Park.2a8bf006.mp4";